var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.468,
    height: 19.393,
    viewBox: "0 0 16.468 19.393",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-144.675 -428.255)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(144.675 429.255)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.926)",
    fill: "none",
    stroke: "#7e9591",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.234,
    cy: 8.234,
    r: 8.234,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.234,
    cy: 8.234,
    r: 7.234,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    y2: 1.115,
    transform: "translate(8.183 0.963)",
    fill: "none",
    stroke: "#7e9591",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 2.129,
    transform: "translate(7.093 0)",
    fill: "none",
    stroke: "#7e9591",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.118,
    transform: "translate(8.133 7.53)",
    fill: "none",
    stroke: "#7e9591",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.118,
    transform: "translate(8.133 10.647)",
    fill: "none",
    stroke: "#7e9591",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 1.115,
    transform: "translate(1.874 3.577) rotate(-45)",
    fill: "none",
    stroke: "#7e9591",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 1.115,
    transform: "translate(14.493 3.577) rotate(45)",
    fill: "none",
    stroke: "#7e9591",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.053a530505c04ce60644a082e3f35360.svg";
export { ForwardRef as ReactComponent };